// @generated by protoc-gen-es v1.0.0 with parameter "target=js+dts,ts_nocheck=false"
// @generated from file api/auth/dto_auth.proto (package com.diagnocat.auth, syntax proto3)
/* eslint-disable */

import { Empty, proto3, Timestamp } from "@bufbuild/protobuf";
import { CalledVia, Deleted } from "../../model/dto_base_pb.js";

/**
 * @generated from message com.diagnocat.auth.Identity
 */
export const Identity = proto3.makeMessageType(
  "com.diagnocat.auth.Identity",
  () => [
    { no: 1, name: "Phone", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "Identity" },
    { no: 2, name: "Email", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "Identity" },
  ],
);

/**
 * @generated from message com.diagnocat.auth.AuthState
 */
export const AuthState = proto3.makeMessageType(
  "com.diagnocat.auth.AuthState",
  () => [
    { no: 100, name: "Objective", kind: "enum", T: proto3.getEnumType(AuthState_AuthObjective) },
    { no: 101, name: "Status", kind: "enum", T: proto3.getEnumType(AuthState_AuthStatus) },
    { no: 102, name: "CurrentStep", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 103, name: "MFA", kind: "message", T: MFARequirement, opt: true },
    { no: 300, name: "CreatedAt", kind: "message", T: Timestamp },
    { no: 301, name: "ExpiresAt", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from enum com.diagnocat.auth.AuthState.AuthObjective
 */
export const AuthState_AuthObjective = proto3.makeEnum(
  "com.diagnocat.auth.AuthState.AuthObjective",
  [
    {no: 0, name: "INVALID_OBJECTIVE"},
    {no: 100, name: "SIGNUP"},
    {no: 101, name: "SIGNUP_VIA_SHARED_PATIENT_INVITATION"},
    {no: 102, name: "SIGNUP_VIA_ORGANIZATION_INVITATION"},
    {no: 103, name: "SIGNUP_VIA_SALESMAN_INVITATION"},
    {no: 104, name: "SIGNIN"},
    {no: 105, name: "RECOVER"},
    {no: 106, name: "SIGNIN_BY_PRESIGN"},
  ],
);

/**
 * @generated from enum com.diagnocat.auth.AuthState.AuthStatus
 */
export const AuthState_AuthStatus = proto3.makeEnum(
  "com.diagnocat.auth.AuthState.AuthStatus",
  [
    {no: 0, name: "INVALID_STATUS"},
    {no: 100, name: "IN_PROGRESS"},
    {no: 101, name: "SUCCESSFUL"},
    {no: 102, name: "FAILED"},
  ],
);

/**
 * @generated from message com.diagnocat.auth.OrganizationAPIKey
 */
export const OrganizationAPIKey = proto3.makeMessageType(
  "com.diagnocat.auth.OrganizationAPIKey",
  () => [
    { no: 1, name: "ID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "OrganizationID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "Secret", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "Created", kind: "message", T: OrganizationAPIKeyCreated },
    { no: 5, name: "ExpiresAt", kind: "message", T: Timestamp },
    { no: 6, name: "Deleted", kind: "message", T: Deleted },
  ],
);

/**
 * Creation metadata specific to organization API keys.
 *
 * @generated from message com.diagnocat.auth.OrganizationAPIKeyCreated
 */
export const OrganizationAPIKeyCreated = proto3.makeMessageType(
  "com.diagnocat.auth.OrganizationAPIKeyCreated",
  () => [
    { no: 1, name: "By", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "At", kind: "message", T: Timestamp },
    { no: 3, name: "Comment", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "Via", kind: "enum", T: proto3.getEnumType(CalledVia) },
  ],
);

/**
 * AdminPermissions are the granular admin-area permissions of a Diagnocat
 * staff admin. Source of truth: the authentication service's
 * `users.Permissions.Admin` subdocument; mirrored into the gate CallContext on
 * every authenticated request.
 *
 * @generated from message com.diagnocat.auth.AdminPermissions
 */
export const AdminPermissions = proto3.makeMessageType(
  "com.diagnocat.auth.AdminPermissions",
  () => [
    { no: 1, name: "BasicAccess", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "APIKey_CanView", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "APIKey_CanDelete", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "APIKey_CanCreate", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "SystemLoad_CanView", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "SystemLoad_CanChange", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 7, name: "AdminPermissions_CanEdit", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 8, name: "FeatureFlags_CanEdit", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 9, name: "Billing_CanEditInventory", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 10, name: "Distributors_CanManage", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 13, name: "DSO_CanManage", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 11, name: "Statistics_CanViewForAllOrganization", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 12, name: "AdminPermissions_CanView", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 14, name: "MFA_CanView", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 15, name: "MFA_CanEnforce", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 16, name: "MFA_CanSetup", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 17, name: "MFA_CanEditAdmin", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 18, name: "BillingZone_CanEdit", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message com.diagnocat.auth.Permissions
 */
export const Permissions = proto3.makeMessageType(
  "com.diagnocat.auth.Permissions",
  () => [
    { no: 1, name: "Admin", kind: "message", T: AdminPermissions },
  ],
);

/**
 * @generated from message com.diagnocat.auth.Presign
 */
export const Presign = proto3.makeMessageType(
  "com.diagnocat.auth.Presign",
  () => [
    { no: 1, name: "Signature", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "ClientKeyID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "SignatureCreationTimestampUnixMilli", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "Objective", kind: "enum", T: proto3.getEnumType(Presign_PresignObjective) },
    { no: 10, name: "UserID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "OrganizationID", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 12, name: "ReportID", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 13, name: "StudyID", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ],
);

/**
 * @generated from enum com.diagnocat.auth.Presign.PresignObjective
 */
export const Presign_PresignObjective = proto3.makeEnum(
  "com.diagnocat.auth.Presign.PresignObjective",
  [
    {no: 0, name: "SIGN_IN"},
    {no: 1, name: "DOWNLOAD"},
  ],
);

/**
 * MFAStatus is the TOTP two-step verification state of a user account.
 *
 * @generated from message com.diagnocat.auth.MFAStatus
 */
export const MFAStatus = proto3.makeMessageType(
  "com.diagnocat.auth.MFAStatus",
  () => [
    { no: 1, name: "Enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "Enforced", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "HasAdminPermissions", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "SetupAt", kind: "message", T: Timestamp },
    { no: 5, name: "RecoveryCodesLeft", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 6, name: "SessionMFAPassed", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
  ],
);

/**
 * @generated from message com.diagnocat.auth.MFA_Enroll_BeginReq
 */
export const MFA_Enroll_BeginReq = proto3.makeMessageType(
  "com.diagnocat.auth.MFA_Enroll_BeginReq",
  () => [
    { no: 1, name: "CurrentCode", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.auth.MFA_Enroll_BeginResp
 */
export const MFA_Enroll_BeginResp = proto3.makeMessageType(
  "com.diagnocat.auth.MFA_Enroll_BeginResp",
  () => [
    { no: 1, name: "Secret", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "OtpauthURI", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.auth.MFA_Enroll_ConfirmReq
 */
export const MFA_Enroll_ConfirmReq = proto3.makeMessageType(
  "com.diagnocat.auth.MFA_Enroll_ConfirmReq",
  () => [
    { no: 1, name: "Code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.auth.MFA_Enroll_ConfirmResp
 */
export const MFA_Enroll_ConfirmResp = proto3.makeMessageType(
  "com.diagnocat.auth.MFA_Enroll_ConfirmResp",
  () => [
    { no: 1, name: "RecoveryCodes", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "SignInRequired", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message com.diagnocat.auth.MFA_SignIn_VerifyReq
 */
export const MFA_SignIn_VerifyReq = proto3.makeMessageType(
  "com.diagnocat.auth.MFA_SignIn_VerifyReq",
  () => [
    { no: 1, name: "TOTPCode", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "Factor" },
    { no: 2, name: "RecoveryCode", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "Factor" },
  ],
);

/**
 * @generated from message com.diagnocat.auth.MFA_DisableReq
 */
export const MFA_DisableReq = proto3.makeMessageType(
  "com.diagnocat.auth.MFA_DisableReq",
  () => [
    { no: 1, name: "CurrentCode", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.auth.AdminMFA_UserReq
 */
export const AdminMFA_UserReq = proto3.makeMessageType(
  "com.diagnocat.auth.AdminMFA_UserReq",
  () => [
    { no: 1, name: "UserID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.auth.AdminMFA_StatusResp
 */
export const AdminMFA_StatusResp = proto3.makeMessageType(
  "com.diagnocat.auth.AdminMFA_StatusResp",
  () => [
    { no: 1, name: "Status", kind: "message", T: MFAStatus },
  ],
);

/**
 * @generated from message com.diagnocat.auth.AdminMFA_EnforceReq
 */
export const AdminMFA_EnforceReq = proto3.makeMessageType(
  "com.diagnocat.auth.AdminMFA_EnforceReq",
  () => [
    { no: 1, name: "UserID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Enforced", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message com.diagnocat.auth.MFARequirement
 */
export const MFARequirement = proto3.makeMessageType(
  "com.diagnocat.auth.MFARequirement",
  () => [
    { no: 1, name: "VerifyRequired", kind: "message", T: Empty, oneof: "Requirement" },
    { no: 2, name: "EnrollRequired", kind: "message", T: Empty, oneof: "Requirement" },
  ],
);

